import React, { FC, SVGProps } from 'react';

/** Desk occupancy sensor — rounded square card with indicator dot and QR hint */
const DeskSensor: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="5.5" cy="5.5" r="1.3" />
    <rect x="7" y="10" width="3.5" height="3.5" rx="0.5" opacity="0.75" />
    <rect x="13.5" y="10" width="3.5" height="3.5" rx="0.5" opacity="0.75" />
    <rect x="7" y="15.5" width="3.5" height="3.5" rx="0.5" opacity="0.75" />
    <rect x="13.5" y="15.5" width="1.5" height="1.5" rx="0.3" opacity="0.75" />
    <rect x="15.5" y="15.5" width="1.5" height="3.5" rx="0.3" opacity="0.75" />
  </svg>
);

export default DeskSensor;
